import VueCookie from "vue-cookie";
/**
 * 获取uuid
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(16);
  });
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  if (key) {
    return JSON.parse(sessionStorage.getItem("permissions") || "[]").indexOf(key) !== -1 || false;
  }
  return true;
}

//默认展开树状表格数据
/**
 *
 * @param el {Object}  vue的el DOM对象
 */
export function expandAll(el) {
  const els = el.getElementsByClassName("el-table__expand-icon");
  for (let i = 0; i < els.length / 2; i++) {
    els[i].click();
  }
}

export function treeDataTranslateBySortPath(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = data[k]["sortPath"].length / 10;
      temp[data[k][pid]]["children"].push(data[k]);
      data[k]["parent"] = temp[data[k][pid]];
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

export function autoExpand(treeDatas, expandedRowIds, id = "id") {
  var index = 0;
  expandedRowIds = uniq(expandedRowIds);
  var expandInfo = { expandedRowIds: expandedRowIds };
  while (expandInfo.expandedRowIds.length > 0 && index < treeDatas.length) {
    var treeData = treeDatas[index];
    var obj = doAutoExpand({ datas: treeDatas, data: treeData, index: index, expandInfo: expandInfo, id: id });
    treeDatas = obj.datas;
    index = obj.index;
    // index++
  }
  return treeDatas;
}
/**
 *
 * 对象比对
 * @param {Object} a
 * @param {Object} b
 * @return {Boolean} true为相同 false为不相同
 * */
export function isObjectValueEqual(a, b) {
  let aProps = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(a)));
  let bProps = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(b)));

  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  return true;
}

function uniq(array) {
  var temp = [];
  var index = [];
  var l = array.length;
  for (var i = 0; i < l; i++) {
    for (var j = i + 1; j < l; j++) {
      if (array[i] === array[j]) {
        i++;
        j = i;
      }
    }
    temp.push(array[i]);
    index.push(i);
  }
  return temp;
}

function isExpanded(obj) {
  if (obj.expandInfo.expandedRowIds.length !== undefined) {
    for (var i = 0; i < obj.expandInfo.expandedRowIds.length; i++) {
      if (obj.expandInfo.expandedRowIds[i] === obj.data[obj.id]) {
        obj.expandInfo.expandedRowIds.splice(i, 1);
        return true;
      }
    }
    return false;
  }
  return false;
}

function doAutoExpand(obj) {
  obj.index++;
  if (isExpanded(obj)) {
    obj.data._expanded = true;
    if (obj.data["children"] !== undefined) {
      var childrenData = obj.data["children"];
      if (childrenData.length !== undefined && childrenData.length > 0) {
        var arrSplice = obj.datas.splice(0, obj.index);
        var arr = arrSplice.concat(childrenData);
        obj.datas = arr.concat(obj.datas);
        for (var i = 0; i < childrenData.length; i++) {
          var d = childrenData[i];
          if (obj.expandInfo.expandedRowIds.length === 0) {
            break;
          }
          var t = doAutoExpand({ datas: obj.datas, data: d, index: obj.index, expandInfo: obj.expandInfo, id: obj.id });
          obj.datas = t.datas;
          obj.index = t.index;
        }
      }
    }
  }
  return obj;
}

export function getExpandedRowIds(datas, id = "id") {
  var expandedRowIds = [];
  for (var i = 0; i < datas.length; i++) {
    var data = datas[i];
    if (data._expanded) {
      expandedRowIds.push(data[id]);
      var childrenData = data["children"];
      if (childrenData) {
        var childrenExpandedIds = getExpandedRowIds(childrenData, id);
        if (childrenExpandedIds.length !== undefined && childrenExpandedIds.length > 0) {
          expandedRowIds = expandedRowIds.concat(childrenExpandedIds);
        }
      }
    }
  }
  return expandedRowIds;
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  VueCookie.delete("token");
  VueCookie.delete("isAdmin");
  VueCookie.delete("appName");
  VueCookie.delete("userName");
  VueCookie.delete("platformName");
  sessionStorage.clear();
}

/**
 * 获取唯一ID
 */
export function getUid() {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuid = s.join("");
  return uuid;
}

/**
 * 遍历数组中的对象，只保留id、name属性
 * @param oldArr 数组，item必须包含ID、NAME、children属性
 */
export function getArrayNameId(oldArr) {
  //遍历
  function ergodic(data, callback) {
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      arr[i] = {
        id: data[i].id,
        name: data[i].name,
      };
      if (data[i].children && data[i].children.length > 0) {
        arr[i].children = callback(data[i].children, callback);
      }
    }
    return arr;
  }
  if (oldArr && oldArr.length > 0) {
    let newArr = ergodic(oldArr, ergodic);
    return newArr;
  } else {
    return [];
  }
}

/**
 * 获取应用名称
 *
 * */
export function getAppName(num) {
  let appName = VueCookie.get("appName");
  return appName;
}

/**
 * @description: 颜色 16进制 转 RGB
 * @param {Object} obj 为一个对象
 * @param {String} obj.color 为一个颜色16进制字符串
 * @param {String} obj.transparent 为此颜色的透明度 1为100%
 * @returns {String} 返回 rgba() 的返回值
 * **/

export function getColorRgbaByHex(obj = { color: "", transparent: "" }) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = obj.color.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    return "RGB(" + colorChange.join(",") + obj.transparent ? obj.transparent : "1" + ")";
  } else {
    console.warn("getColorRgbaByHex:传入的参数值不符合色彩16进制规范。");
    return color;
  }
}

export const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      //IE
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      //Others
      script.onload = function () {
        // console.log("complete");
        resolve();
      };
      script.onerror = function (e) {
        reject(e);
      };
    }
    script.src = url;
    document.getElementsByTagName("body")[0].appendChild(script);
  });
};
